export const SESSION_INACTIVITY_MS = 30 * 60 * 1000;
export const SESSION_ACTIVITY_STORAGE_KEY = "odonto.sessionLastActivity";

export type SessionActivity = { userId: string; at: number };

export const isSessionInactive = (lastActivity: number, now: number, timeout = SESSION_INACTIVITY_MS) =>
  !Number.isFinite(lastActivity) || now - lastActivity >= timeout;

export const parseSessionActivity = (value: string | null): SessionActivity | null => {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value) as Partial<SessionActivity>;
    if (typeof parsed.userId !== "string" || !parsed.userId || !Number.isFinite(parsed.at)) return null;
    return { userId: parsed.userId, at: Number(parsed.at) };
  } catch {
    return null;
  }
};

export const serializeSessionActivity = (activity: SessionActivity) => JSON.stringify(activity);
